import initialState from '../initialState'
import {
  TOGGLE_TERMS_AND_CONTDITIONS,
  EXPAND_TERMS_AND_CONTDITIONS
} from '../actions'

export function termsAndConditionsOpen (
  state = initialState.termsAndConditionsOpen,
  action
) {
  switch (action.type) {
    case TOGGLE_TERMS_AND_CONTDITIONS:
      return !state

    case EXPAND_TERMS_AND_CONTDITIONS:
      return true
    default:
      return state
  }
}
